<template>
  <b-modal id="reviewDetailModal" title="리뷰 상세" size="md" centered>
    <div class="search user_modal review_detail">
      <div class="review_detail_head">
        <div class="head_item">
          <span class="tag_label">별점</span>
          <StarRating :rating="reviewData.clinical_rating" />
        </div>
        <div class="head_item">
          <span class="tag_label">등록자</span>
          <span class="review_writer">{{ reviewData.nick_nm }}</span>
        </div>
      </div>

      <div class="review_detail_tags">
        <div class="tag_row" v-if="reviewData.symptom_change_nm">
          <span class="tag_label">처방 후 증상</span>
          <span class="tag_value">{{ reviewData.symptom_change_nm }}</span>
        </div>
        <div class="tag_row" v-if="reviewData.adverse_reaction_nm">
          <span class="tag_label">부작용</span>
          <span class="tag_value">{{ reviewData.adverse_reaction_nm }}</span>
        </div>
        <div class="tag_row" v-if="reviewData.followup_action_nm">
          <span class="tag_label">사용방법</span>
          <span class="tag_value">{{ reviewData.followup_action_nm }}</span>
        </div>
        <div class="tag_row" v-if="reviewData.evaluation_period_nm">
          <span class="tag_label">평가기간</span>
          <span class="tag_value">처방 후 {{ reviewData.evaluation_period_nm }}</span>
        </div>
        <div class="tag_row" v-if="reviewData.medication_adherence_nm">
          <span class="tag_label">복용량</span>
          <span class="tag_value">{{ reviewData.medication_adherence_nm }}</span>
        </div>
      </div>

      <div class="review_detail_content">
        <p class="qa_sub_title">종합평가</p>
        <div class="content_box">{{ reviewData.review_content || '작성된 내용이 없습니다.' }}</div>
      </div>
    </div>
    <template #modal-footer="{ ok }">
      <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
    </template>
  </b-modal>
</template>

<script>
import StarRating from "@/components/common/StarRating.vue";

export default {
  name: 'reviewDetailModal',
  components: {
    StarRating
  },
  data() {
    return {
      reviewData: {
        clinical_rating: 0,
        symptom_change_nm: '',
        adverse_reaction_nm: '',
        followup_action_nm: '',
        evaluation_period_nm : '',
        followup_content : '',
        medication_adherence_nm : '',
        review_content: '',
        nick_nm: ''
      }
    };
  },
  methods: {
    open(item) {
      this.reviewData = item;
      this.$bvModal.show('reviewDetailModal');
    }
  }
};
</script>

<style scoped>
.review_detail_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.head_item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.head_item .tag_label {
  flex: none;
}
.review_writer {
  font-size: 1.4rem;
  color: #666;
  font-weight: 600;
}
.review_detail_tags {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}
.tag_row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tag_label {
  flex: 0 0 100px;
  font-size: 1.3rem;
  font-weight: 700;
  color: #78420c;
}
.tag_value {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  background-color: #f4ece1;
  color: #4a3f1a;
  font-size: 1.3rem;
}
.qa_sub_title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #666;
  margin-bottom: 8px;
}
.content_box {
  min-height: 100px;
  max-height: 300px;
  overflow-y: auto;
  padding: 14px 16px;
  background-color: #fdf6d8;
  border: 1px solid #e5d6a8;
  border-radius: 8px;
  color: #4a3f1a;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
  font-size: 1.4rem;
}
</style>